import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "../styles/BlogDetails.css";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm"; 
import { Helmet } from "react-helmet-async";
import HomeFooter from "../components/Home/HomeFooter";
import MainHeader from "../components/Main/MainHeader";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    axios
      .get(`https://anyworq.com/api/blogs/${id}`)
      .then((res) => setBlog(res.data))
      .catch((err) => console.error("Error fetching blog:", err));
  }, [id]);

 if (!blog) return <p className="loading">Loading blog details...</p>;

  const pageTitle = `${blog.title} | Anyworq – A to Z Services in Bangalore`;
  const pageDescription =
    blog.content.length > 150
      ? blog.content.substring(0, 150) + "..."
      : blog.content;
  const canonicalUrl = `https://www.anyworq.com/blogs/${blog._id}`;

  return (
    <>
    <MainHeader />
      <Helmet>
        {/* Meta Tags */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta
          name="keywords"
          content={`Anyworq blog, ${blog.title}, ${blog.category}, services Bangalore`}
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={canonicalUrl} />
        <meta
          property="og:image"
          content={blog.image || "https://www.anyworq.com/Favicon.png"}
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta
          name="twitter:image"
          content={blog.image || "https://www.anyworq.com/Favicon.png"}
        />

        {/* Structured Data (Schema.org) */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": "${blog.title}",
            "image": "${blog.image || "https://www.anyworq.com/Favicon.png"}",
            "author": {
              "@type": "Person",
              "name": "${blog.author}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Anyworq",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.anyworq.com/Favicon.png"
              }
            },
            "datePublished": "${blog.createdAt}",
            "url": "${canonicalUrl}",
            "description": "${pageDescription}"
          }
          `}
        </script>
      </Helmet>

      {/* Blog Content */}
      <div className="blog-details">
        <Link to="/blog" className="back-link">
          ← Back to Blogs
        </Link>
        <h1 className="blog-title">{blog.title}</h1>
        {blog.image && (
          <img src={blog.image} alt={blog.title} className="blog-image" />
        )}
        <p className="blog-meta">
          <strong>Author:</strong> {blog.author} |{" "}
          {new Date(blog.createdAt).toLocaleDateString()}
        </p>
        <div className="blog-body">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {blog.content}
          </ReactMarkdown>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default BlogDetails;
